import { transformTypeDestinationResponse } from './transformer-type-destination';

export const transformRequestTypeDestination = (
  values: transformTypeDestinationResponse
): RequestReturn => {
  return {
    codice: Number.parseInt(values?.code || '') || undefined,
    descrizione: values?.description || undefined,
    nomeCoda: values?.queueName || undefined,
  };
};

interface RequestReturn {
  codice?: number;
  descrizione?: string;
  nomeCoda?: string;
}
